/**
 * 增值包（流量包 / AI 精准回复订单数）购买入口显隐开关。
 * 新版订阅不再支持增值包新购，存量已购展示与账单补缴不受影响；
 * 如需恢复购买入口，改回 true 即可。
 */
export const SHOW_ADDON_PACKAGE_ORDER_ENTRY = false;
